'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { Body, clsxm, FlexContainer, Heading } from '@bridge/ui';
import AuthMethodSelector from './_components/AuthMethodSelector';
import MagicLinkForm from './_components/MagicLinkForm';
import SSOLoginForm from './_components/SSOLoginForm';
import { useAuthentication } from './_hooks/useAuthentication';
import BridgeWordmark from 'components/brand/BridgeWordmark';
import type { ReactElement } from 'react';
interface LoginFormProps {
  nextPath?: string;
  isSupportAuth?: boolean;
}
export interface LoginFormViewProps {
  isGeneratingLink: boolean;
  isSupportAuth?: boolean;
  initialMethod?: 'default' | 'sso';
  onGoogleClick: () => void;
  onMagicLinkSubmit: (values: {
    email: string;
  }) => Promise<void>;
  onSSOSubmit: (values: {
    email: string;
  }) => Promise<void>;
}
export function LoginFormView(t0) {
  const $ = _c(17);
  const {
    initialMethod: t1,
    isGeneratingLink,
    isSupportAuth,
    onGoogleClick,
    onMagicLinkSubmit,
    onSSOSubmit
  } = t0;
  const initialMethod = t1 === undefined ? "default" : t1;
  const [showSSOInput, setShowSSOInput] = useState(initialMethod === "sso");
  const [shouldShake, setShouldShake] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShouldShake(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleValidationError = t2;
  const t3 = shouldShake && "apply-shake";
  let t4;
  if ($[1] !== t3) {
    t4 = clsxm("relative h-fit w-full max-w-md rounded-lg border border-b-2 border-border-secondary bg-background-primary p-8 sm:w-[420px] sm:p-12", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setShouldShake(false);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative mb-6 text-center"><a href="https://www.bridge.xyz" rel="noopener noreferrer" target="_blank"><BridgeWordmark /></a></div>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== isSupportAuth) {
    t7 = isSupportAuth && <FlexContainer className="mb-4 text-center gap-2" direction="column" items="center"><Heading size="md">Authorize Bridge Support</Heading><Body className="text-content-secondary" size="md">Sign in to authorize Bridge Support to respond to your ticket in Slack.</Body></FlexContainer>;
    $[5] = isSupportAuth;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== isGeneratingLink || $[8] !== onGoogleClick || $[9] !== onMagicLinkSubmit || $[10] !== onSSOSubmit || $[11] !== showSSOInput) {
    t8 = showSSOInput ? <SSOLoginForm isGeneratingLink={isGeneratingLink} onBackClick={() => setShowSSOInput(false)} onSubmit={onSSOSubmit} onValidationError={handleValidationError} /> : <><AuthMethodSelector onGoogleClick={onGoogleClick} onSSOClick={() => setShowSSOInput(true)} /><MagicLinkForm isGeneratingLink={isGeneratingLink} onSubmit={onMagicLinkSubmit} onValidationError={handleValidationError} /></>;
    $[7] = isGeneratingLink;
    $[8] = onGoogleClick;
    $[9] = onMagicLinkSubmit;
    $[10] = onSSOSubmit;
    $[11] = showSSOInput;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className={t4} onAnimationEnd={t5}>{t6}{t7}{t8}</div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}
const LoginForm = t0 => {
  const $ = _c(8);
  const {
    isSupportAuth,
    nextPath
  } = t0;
  let t1;
  if ($[0] !== nextPath) {
    t1 = {
      nextPath
    };
    $[0] = nextPath;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isGeneratingLink,
    handleMagicLinkSubmit,
    handleSSOSubmit,
    startOAuthFlow
  } = useAuthentication(t1);
  let t2;
  if ($[2] !== handleMagicLinkSubmit || $[3] !== handleSSOSubmit || $[4] !== isGeneratingLink || $[5] !== isSupportAuth || $[6] !== startOAuthFlow) {
    t2 = <LoginFormView isGeneratingLink={isGeneratingLink} isSupportAuth={isSupportAuth} onGoogleClick={startOAuthFlow} onMagicLinkSubmit={handleMagicLinkSubmit} onSSOSubmit={handleSSOSubmit} />;
    $[2] = handleMagicLinkSubmit;
    $[3] = handleSSOSubmit;
    $[4] = isGeneratingLink;
    $[5] = isSupportAuth;
    $[6] = startOAuthFlow;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default LoginForm;